<form name="infoForm" class="info-form Marginbox__b-medium  profile-content" autocomplete="off">
  <div>
    <gen-qms-section class="results-pane"
                     *ngIf="(QMSValues && QMSValues.available)
                          && (currentRevision['ui'] && currentRevision['ui']['qms'] && currentRevision['ui']['qms']['visible'])"
                     [status]="currentOrder.non_conformance_alert"
                     [testNumber]="currentOrder.identifiers[0].value"
                     [diagnosticOrderId]="currentOrder.id"
                     (statusUpdate)="currentOrder.non_conformance_alert = $event"></gen-qms-section>

    <div class="results-pane case_info">
      <div class="info-dynamic-form">

        <div class="results-pane-subheader">{{'Case Info' | translate}}</div>

        <div class="Flexbox_max_width_100 results-pane-item div_wide compact-div">
          <span class="results-pane-caption caption_wide" >{{'Assigned to' | translate}}</span>

          <ng-container *ngIf="isAdmin();else notAdminUser">
            <ng-container *ngIf="currentOrder?.performingPractitioner;else emptyPract">
              <span class="results-pane-value" id="test-info-assigned-to">{{currentOrder.performingPractitioner}}</span>
            </ng-container>
            <ng-template #emptyPract>
              <span class="results-pane-value" id="test-info-assigned-to">ISPM Admin</span>
            </ng-template>
          </ng-container>
          <ng-template #notAdminUser>
            <span class="results-pane-value" id="test-info-assigned-to">{{currentOrder?.performingPractitioner ? currentOrder.performingPractitioner : "Unassigned"}}</span>
          </ng-template>
        </div>

        <div class="Flexbox_max_width_100 results-pane-item div_wide compact-div" *ngIf="currentOrder?.orderByPractitioner">
          <span class="results-pane-caption caption_wide">{{'Order by' | translate}}</span>
          <span class="results-pane-value" id="test-info-order-by">{{currentOrder?.orderByPractitioner}}</span>
        </div>

        <div *ngIf="!testConfiguration.hideTestNumberAndType">

          <div class="Flexbox_max_width_100 results-pane-item div_wide compact-div">
            <span class="results-pane-caption caption_wide" >{{'Test Number' | translate}}</span>
            <span class="results-pane-value" id="test-info-test-number">{{currentOrder.identifiers[0].value}}</span>
            <span class="fs9" style="width:25%; padding-left: 0.42rem;padding-top: 0.57rem;">{{currentRevision.name}}</span>
          </div>

          <div class="Flexbox_max_width_100 results-pane-item div_wide compact-div">
            <span class="results-pane-caption caption_wide">{{'Test Type' | translate}}</span>
            <span class="results-pane-value" id="test-info-test-type">{{currentOrder.workflowRequest.name}}</span>
          </div>

        </div>

      </div>
    </div>

  </div>

  <div class="Flexbox Flexbox__direction-rows results-pane" style="flex: 1 0 auto;width: 75%">
    <ng-container *ngIf="formsConfig">
      <div *ngFor="let formConfig of formsConfig; trackBy: trackByFormId" class="order-form-content Flexbox ">
        <gen-dynamic-form class="info-dynamic-form"
                          [formName]="formConfig.formId"
                          [title]="formConfig.title"
                          [subTitle]="formConfig.subTitle"
                          [overrides]="formsOverrides"
                          [cancelFetchUpdatedFields]="isNewOrder"
                          [disabled]="!isEditableField"
                          [disabledForced]="!isAssignee"
                          [reInitializeForm]="reInitializeForm"
                          [formData]="formConfig.key ? currentOrder[formConfig.key] : currentOrder"
                          [editMode]="true"
                          (formChange)="updateDiagnosticOrder($event.updated,$event.form,formConfig.key)"
                          [updateField]="updateFormObject"
                          [updatedFieldsContext]="currentRevision.id"
                          [submitted]="true"
        ></gen-dynamic-form>
      </div>
    </ng-container>
  </div>

  <div class="Flexbox Flexbox__direction-rows results-pane" style="flex: 1 0 auto;"
       *ngIf="!isInputExist('userInputButton',['SpecimenShipped','SpecimenCheckedOut','SpecimenRequest']) && !(testConfiguration.specimensTabConfig && testConfiguration.specimensTabConfig.specimensTabEnabled)">
    <gen-sample-viewer
      *ngIf="testConfiguration.specimenConfig"
      (updatedOrder)="emitUpdate($event)"
      [overrides]="formsOverrides"
      [samples]="currentOrder.specimen"
      [sampletype]="testConfiguration.specimenConfig[0]?.specimenType"
      [callback]="inputFocusout"
      [showaddbutton]="testConfiguration.allowAddSpecimen"
      [samplesConfig]="testConfiguration.specimenConfig"
      [disabledForced]="!this.isAssignee"
      [primaryid]="currentOrder.primaryTumor"
      [editMode]="true"
      [allowedit]="isEditableField">
    </gen-sample-viewer>
  </div>

  <div *ngIf="isInputExist('userInputButton',['SpecimenShipped','SpecimenCheckedOut','SpecimenRequest'])"
       class="proceedNextStepButton">
    <input *ngFor="let inputButton of inputs"
           [disabled]="currentOrder.performer !== userId"
           type="button" class="btn btn-primary button-padding"
           (click)="performWorkflowStep(['uiGeneralInput'], 'uiGeneralInput', inputButton.args)"
           [value]="inputButton.value"/>
  </div>

  <div class="Flexbox Flexbox__box-direction-column-reverse results-pane  Marginbox__r-medium Spacebox__t-medium "
           *ngIf="(isActiveStep('reviewQCResults')|| isActiveStep('pipelineFailed')) && showDueTestType()">

    <input type="button" class="btn btn-primary" (click)="confirmSpecimen()"
           [value]="isInputExist('userInputButton',['proceedWithSpecimen']).value"
           *ngIf="isActiveStep('reviewQCResults')"/>

    <input type="button" class="btn btn-primary" (click)="failTest()"
           [value]="isInputExist('userInputButton',['failTest']).value"
           *ngIf="isActiveStep('pipelineFailed')"/>

    <input type="button" class="btn btn-primary Marginbox__lr-small" (click)="rejectSpecimen()"
           [value]="isInputExist('userInputButton',['rejectSpecimen','revertToWetlab']).value"/>
  </div>

  <span class="results-pane blurb-text Flexbox">{{testConfiguration.blurb}}</span>

</form>
